import { fetcher } from 'services/helpers/responseHandler'

// Chat Response
const chatRespond = async (subsidiaryId, propertyId, message, conversationId) => {
  return fetcher.post('llm-platform/v1/chat/respond', {
    message,
    conversationId: conversationId || null,
    subsidiaryId: subsidiaryId,
    propertyId: propertyId || null
  })
}

// Campaign Generation
const generateCampaign = async (subsidiaryId, propertyId, goal, channel, tone, variantCount) => {
  return fetcher.post('llm-platform/v1/campaign/generate', {
    goal,
    channel,
    tone,
    variantCount: variantCount,
    subsidiaryId: subsidiaryId,
    propertyId: propertyId || null
  })
}

// CSM Copilot
const csmAnswer = async (subsidiaryId, propertyId, question) => {
  return fetcher.post('llm-platform/v1/csm/answer', {
    question,
    subsidiaryId: subsidiaryId,
    propertyId: propertyId || null
  })
}

// Forecast
const getForecast = async (subsidiaryId, propertyId, monthsAhead) => {
  return fetcher.post('llm-platform/v1/forecast/occupancy', {
    monthsAhead: monthsAhead,
    subsidiaryId: subsidiaryId,
    propertyId: propertyId || null
  })
}

// Campaign Recommendations
const getCampaignRecommendations = async (subsidiaryId, propertyId, timeWindow) => {
  return fetcher.post('llm-platform/v1/recommend/campaigns', {
    timeWindow: timeWindow,
    subsidiaryId: subsidiaryId,
    propertyId: propertyId || null
  })
}

// Intent Classification
const classifyIntent = async (message) => {
  return fetcher.post('llm-platform/v1/intent/classify', {
    message
  })
}

const llmPlatformApi = {
  chatRespond,
  generateCampaign,
  csmAnswer,
  getForecast,
  getCampaignRecommendations,
  classifyIntent
}

export default llmPlatformApi
